import axios from "axios";
import { API_BASE_URL } from "../../services/endpoints";

export const loginWithCredentials = async (email, password) => {
  const response = await axios.post(
    `${API_BASE_URL}/api/v1/auth/login`,
    {
      username: email,
      password,
    },
    { headers: { "Content-Type": "application/json" } }
  );
  return response.data;
};

export const loginWithGoogle = async (idToken) => {
  const response = await axios.post(
    `${API_BASE_URL}/api/v1/oauth/login-google`,
    { idToken },
    { headers: { "Content-Type": "application/json" } }
  );
  return response.data;
};
